export const tableHeaders = [
  { label: 'CMS Id', value: 'cmsPageId' },
  { label: 'Title', value: 'title' },
  { label: 'Category', value: 'category' },
  { label: 'Status', value: 'isActive' },
  { label: 'Slug', value: 'slug' },
  { label: 'Content', value: 'content' }
]

export const promotionCategories = [
  { label: 'Casino Promotion', value: 1 },
  { label: 'Sponsorship', value: 3 },
]

export const category = ['Support', 'About', 'Responsible Gaming']


export const tableColumnHeaders = [
  { accessorKey: 'promotionId', Header: 'promotionId', value: 'id', label: 'Id' },
  { accessorKey: 'category', Header: 'category', value: 'type', label: 'Type' },
  { accessorKey: 'title', Header: 'Title', value: 'title', label: 'Title' },
  { accessorKey: 'image', Header: 'image', value: 'Image', label: 'Image' },
  { accessorKey: 'slug', Header: 'Slug', value: 'slug', label: 'Slug' },
  { accessorKey: 'status', Header: 'Status', value: 'status', label: 'Status' },
  // { accessorKey: 'action', Header: 'Action', value: 'action', label: 'Action' }
];
